export const HPrepareReturnData = (locationInfo: google.maps.places.PlaceResult) => {
  const { address_components = [], geometry, formatted_address = "" } = locationInfo;
  const addressComponents = address_components;

  const latLng = {
    lat:
      typeof geometry?.location?.lat == "function"
        ? geometry?.location?.lat()
        : (geometry?.location?.lat as unknown as number),
    lng:
      typeof geometry?.location?.lng == "function"
        ? geometry?.location?.lng()
        : (geometry?.location?.lng as unknown as number)
  };

  const fullLocation = {
    ...latLng,
    address: formatted_address,
    country: addressComponents.find((comp: any) => comp.types.includes("country"))
      ?.long_name,
    province: addressComponents.find((comp: any) =>
      comp.types.includes("administrative_area_level_1")
    )?.long_name,
    city:
      addressComponents.find((comp: any) => comp.types.includes("locality"))
        ?.long_name ||
      addressComponents.find((comp: any) =>
        comp.types.includes("administrative_area_level_2")
      )?.long_name,

    sector: addressComponents.find((comp: any) => comp.types.includes("sublocality"))
      ?.long_name,

    postalCode: addressComponents.find((comp: any) =>
      comp.types.includes("postal_code")
    )?.long_name
  };

  const address = [fullLocation.province, fullLocation.city, fullLocation.sector]
    .filter(x => x)
    .join(", ");

  return {
    ...fullLocation,
    address
  };
};
